'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

module.exports = function (_ref) {
  var libp2p = _ref.libp2p;
  return /*#__PURE__*/function () {
    var _peers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
      var verbose, peers, _iterator, _step, _step$value, peerId, connections, _iterator2, _step2, connection, tupple;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              options = options || {};
              verbose = options.v || options.verbose;
              peers = [];
              _iterator = _createForOfIteratorHelper(libp2p.connections);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray(_step.value, 2), peerId = _step$value[0], connections = _step$value[1];
                  _iterator2 = _createForOfIteratorHelper(connections);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      connection = _step2.value;
                      tupple = {
                        addr: connection.remoteAddr,
                        peer: peerId
                      };

                      if (verbose || options.direction) {
                        tupple.direction = connection.stat.direction;
                      }

                      if (verbose) {
                        tupple.muxer = connection.stat.multiplexer;
                        tupple.latency = 'n/a';
                      }

                      peers.push(tupple);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              return _context.abrupt("return", peers);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function peers(_x) {
      return _peers.apply(this, arguments);
    }

    return peers;
  }();
};